import {events} from '../events';

export const setColumns = ({namespace, columnDefs}) => ({
    type: events.COLUMN_DEFS_SAVE,
    payload: {
        namespace,
        columnDefs
    }
});
